import { svnsMatches2026 } from "../matches/matches2026Svns";
import { matches2026SvnsBordeaux } from "./bordeaux/matches2026SvnsBordeaux";

export const allSvnsMatches = [
  ...svnsMatches2026,
  ...matches2026SvnsBordeaux,
];